<!--
패킹 컴포넌트 > 결과정보
------------------------------------
-->
<template>
    <div class="uk-card uk-card-default uk-card-small">
        <table class="house-info">
            <colgroup>
                <col style="width: 150px">
                <col>
            </colgroup>


            <tr>
                <th>
                    <i class="material-icons">
                        info
                    </i>
                    패키지 수
                </th>
                <td>
                    {{ house.package_amount }}
                    <span class="uk-text-muted">개</span>

                    <div
                        v-for="(pack, index) in packages"
                        :key="pack.id"
                        class="package-info"
                    >
                        {{ pack.weight }}
                        <span class="uk-text-muted">kg</span>

                        {{ pack.volume_x }}
                        <span class="uk-text-muted">cm</span>

                        {{ pack.volume_y }}
                        <span class="uk-text-muted">cm</span>

                        {{ pack.volume_z }}
                        <span class="uk-text-muted">cm</span>
                    </div>
                </td>
            </tr>

            <tr>
                <th>
                    <i class="material-icons">
                        info
                    </i>
                    총 무게
                </th>
                <td class="highlight">
                    {{ house.weight }}
                    <span class="uk-text-muted">kg</span>
                </td>
            </tr>

            <tr>
                <th>
                    <i class="material-icons">
                        playlist_add_check
                    </i>
                    포장옵션
                </th>
                <td class="highlight">
                    <div class="uk-flex uk-flex-left uk-flex-wrap">
                        <div
                            v-for="(opt, index) in packOptionCosts"
                            :key="opt.id"
                            class="pack-option"
                        >
                            <i class="material-icons">
                                check_box
                            </i>
                            {{ opt.name }}
                        </div>
                    </div>
                </td>
            </tr>

            <tr>
                <th>
                    <i class="material-icons">
                        mail
                    </i>
                    회원 사서함
                </th>
                <td>
                    {{ house.user_mailbox }}
                </td>
            </tr>
<!--
            <tr>
                <th>
                    <i class="material-icons">
                        home
                    </i>
                    회원사
                </th>
                <td>
                    {{ house.user_nick }}
                </td>
            </tr>
-->
            <tr>
                <th>
                    <i class="material-icons">
                        account_box
                    </i>
                    받는사람
                </th>
                <td class="highlight">
                    {{ house.name }}

                    <button
                        type="button"
                        class="uk-button uk-button-dg-w-lg uk-button-on-dg-w-dg uk-button-small"
                        onclick="$.app.on_event.move(arguments);"
                        :data-url="'/houses/' + house.id + '/first-prod?tab=pack-info'"
                        data-target="_blank"
                    >
                        <span uk-icon="icon: link"></span>
                        상품상세
                    </button>
                </td>
            </tr>


            <tr>
                <th>
                    <i class="material-icons">
                        flight
                    </i>
                    HAWB
                </th>
                <td class="highlight">
                    {{ house.hawb }}
                </td>
            </tr>

            <tr>
                <th>
                    <i class="material-icons">
                        local_shipping
                    </i>
                    BLNO
                </th>
                <td>
                    {{ house.blno }}
                </td>
            </tr>




            <tr>
                <th>
                    <i class="material-icons">
                        local_post_office
                    </i>
                    우편번호
                </th>
                <td>
                    {{ house.zipcode }}
                </td>
            </tr>



            <tr>

                <th>
                    <i class="material-icons">
                        location_on
                    </i>
                    주소
                </th>
               <td>
                   {{ house.addr1 }}
                   {{ house.addr2 }}
               </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // 하우스정보
            house: Object,

            // 패키지정보
            packages: Array,

            // 포장옵션정보
            packOptionCosts: Array,
        },
        data: function () {
            return {
            };
        },
        computed: {

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
    .house-info {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .material-icons {
            font-size: 1.5rem;
        }

        th, td {
            text-align: left;
            border: 1px solid #cfcfcf;
            font-weight: normal;
            min-width: 150px;
            padding: 10px;
            //color: #000;
        }

        th {
            font-size: 1rem;
            background-color: #fefefe;

            .material-icons {
                color: #aaa;
            }

        }
        td {
            font-size: 1rem;

            &.highlight {
                color: #1e87f0;
            }
        }

    }

    .package-info {
        margin-left: 20px;
        padding: 3px;
        background-color: #fafafa;
        font-size: 1rem;
        color: #666;
    }

    .pack-option {
        margin-right: 15px;
        margin-bottom: 15px;
        padding: 5px;
        color: #1e87f0;
    }
</style>